import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "overlay overlay-dark opacity-8 z-index-1" }, null, -1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 offset-lg-3" }
const _hoisted_5 = { class: "page-titles whitecolor text-center padding_top padding_bottom" }
const _hoisted_6 = { class: "font-bold text-color-main" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"gradient-bg title-wrap bg-custom\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 whitecolor\"><h3 class=\"float-left\">Berita</h3><ul class=\"breadcrumb top10 bottom10 float-right\"><li class=\"breadcrumb-item\"><a href=\"/\">Beranda</a></li><li class=\"breadcrumb-item\">Berita</li></ul></div></div></div>", 1)
const _hoisted_8 = {
  id: "our-blog",
  class: "bglight padding_top padding_bottom_half"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-8 col-md-7" }
const _hoisted_12 = { class: "news_item shadow-equal" }
const _hoisted_13 = { class: "image" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "news_desc text-center text-md-left",
  style: {"background-color":"#fff !important","background-image":"none !important"}
}
const _hoisted_16 = { class: "text-capitalize font-normal darkcolor" }
const _hoisted_17 = { class: "meta-tags top20 bottom20" }
const _hoisted_18 = { href: "#." }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "col-lg-4 col-md-5" }
const _hoisted_22 = { class: "sidebar whitebox mt-5 mt-md-0" }
const _hoisted_23 = {
  key: 0,
  class: "widget shadow-equal heading_space_half text-center text-md-left"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", { class: "text-capitalize darkcolor bottom20" }, " Dokumen Pendukung ", -1)
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down-fill" }, null, -1)
const _hoisted_27 = {
  class: "widget heading_space_half shadow-equal wow fadeIn",
  "data-wow-delay": "350ms"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", { class: "text-capitalize darkcolor bottom20 text-center text-md-left" }, " Berita Terbaru ", -1)
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "text" }
const _hoisted_32 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      id: "main-banner-page",
      class: "position-relative page-header section-nav-smooth parallax blog-detail-header",
      style: _normalizeStyle(`background-image: url(${_ctx.dataBerita.thumbnail});background-size: 100%;`)
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.dataBerita.title), 1)
            ])
          ])
        ]),
        _hoisted_7
      ])
    ], 4),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.dataBerita.thumbnail,
                  alt: "Latest News",
                  class: "img-responsive"
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.dataBerita.title), 1),
                _createElementVNode("ul", _hoisted_17, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", _hoisted_18, [
                      _hoisted_19,
                      _createTextVNode(_toDisplayString(_ctx.dataBerita.created_at), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  innerHTML: _ctx.dataBerita.content
                }, null, 8, _hoisted_20)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("aside", _hoisted_22, [
              (_ctx.dataBerita.document != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("a", {
                      target: "_blank",
                      href: _ctx.dataBerita.document,
                      class: "btn btn-sm btn-secondary w-100"
                    }, [
                      _hoisted_26,
                      _createTextVNode(" Download PDF ")
                    ], 8, _hoisted_25)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRecent, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "single_post d-table bottom15"
                  }, [
                    _createElementVNode("a", {
                      href: `/news-detail?prefix=${item.slug}`,
                      class: "post"
                    }, [
                      _createElementVNode("img", {
                        style: {"height":"100%","object-fit":"cover"},
                        src: _ctx.getFilePath('news', item.thumbnail),
                        alt: "post image"
                      }, null, 8, _hoisted_30)
                    ], 8, _hoisted_29),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("a", {
                        href: `/news-detail?prefix=${item.slug}`
                      }, _toDisplayString(item.title), 9, _hoisted_32),
                      _createElementVNode("span", null, _toDisplayString(_ctx.fomatDateTimeIndo(item.createdAt)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}